import { MovementContextInterface } from './MovementInterface';

export const movementInitialState: MovementContextInterface = {
  isDrawerOpen: false,
  movements: undefined,
  isCalendarOpen: false,
};
